import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    if (user && user.role === "admin") return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await login(email, password);
            toast.success("Authenticated.");
            nav("/admin");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050510] text-white flex items-center justify-center p-6">
            <div className="absolute inset-0 photonic-grid opacity-20 pointer-events-none" />
            <div className="relative w-full max-w-md">
                <div className="tech-card p-10">
                    <div className="flex items-center gap-3 mb-8">
                        <Lock size={18} className="text-[var(--accent-indigo)]" />
                        <div className="overline">Skovomax · Admin</div>
                    </div>
                    <h1 className="font-serif-display text-4xl mb-2">Authenticate.</h1>
                    <p className="text-white/55 text-sm mb-8">
                        Restricted access — content management system.
                    </p>
                    <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
                        <div>
                            <label className="tech-label mb-2 block">Email</label>
                            <input
                                required
                                type="email"
                                className="tech-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="admin-email"
                            />
                        </div>
                        <div>
                            <label className="tech-label mb-2 block">Password</label>
                            <input
                                required
                                type="password"
                                className="tech-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-password"
                            />
                        </div>
                        {error && (
                            <div className="font-mono-tech text-[11px] tracking-[0.14em] uppercase text-red-400">
                                {error}
                            </div>
                        )}
                        <button
                            type="submit"
                            className="btn-primary w-full"
                            disabled={loading}
                            data-testid="admin-login-submit"
                        >
                            {loading ? "Authenticating…" : "Access System"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
